import { NodeSelection } from "@tiptap/pm/state"

import { toggleList } from "@/tiptap/ui/list-button/use-list"

const LIST_NODE_TYPES = new Set(["bulletList", "orderedList", "taskList"])

function getActiveCalloutNode(editor) {
  const { selection } = editor.state

  if (selection instanceof NodeSelection && selection.node.type.name === "callout") {
    return {
      node: selection.node,
      pos: selection.from,
    }
  }

  const { $anchor } = selection
  for (let depth = $anchor.depth; depth > 0; depth--) {
    const node = $anchor.node(depth)

    if (node.type.name === "callout") {
      return {
        node,
        pos: $anchor.before(depth),
      }
    }
  }

  return null
}

export function turnActiveCalloutListIntoList(editor, type) {
  if (!editor || !LIST_NODE_TYPES.has(type)) return false

  const callout = getActiveCalloutNode(editor)
  const innerNode = callout?.node.childCount === 1 ? callout.node.firstChild : null
  if (!callout || !innerNode || !LIST_NODE_TYPES.has(innerNode.type.name)) return false

  const tr = editor.state.tr.replaceWith(
    callout.pos,
    callout.pos + callout.node.nodeSize,
    innerNode,
  )
  editor.view.dispatch(tr)
  editor.commands.focus()

  if (innerNode.type.name === type) {
    return true
  }

  editor.view.dispatch(
    editor.state.tr.setSelection(NodeSelection.create(editor.state.doc, callout.pos)),
  )

  return toggleList(editor, type)
}
